import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Filter, Plus } from "feather-icons-react/build/IconComponents";
import Swal from "sweetalert2";
import { all_routes } from "../../../Router/all_routes";
import httpService from "../../../services/http/settings/country.service";
import usePagination, { createInitialPagination } from "../../../custom-hooks/usePagination";
import { useNavigate } from "react-router-dom";
import ConfirmationAlert from "../../../components/confirm-alert";
import UnlimitTable from "../../../components/ui-kit/unlimit-table";
import UnlimitBreadcrumb from "../../../components/ui-kit/unlimit-breadcrumb";
import { useSelector } from "react-redux";
import moment from "moment";
import ReactCountryFlag from "react-country-flag";
import { useTranslation } from "react-i18next";
import useRoleAndPerm from "../../../utils/permissionFunction";
const CountryList = () => {
  const { hasPermission } = useRoleAndPerm();
  const navigate = useNavigate();
  const [nameFilter, setNameFilter] = useState("");
  const [loading, setLoading] = useState(false);
  const [countrys, setCountrys] = useState([]);
  const [company, setVendor] = useState([]);
  const companies = useSelector((state) => state.companies.companies);
  const [selectedUOMId, setSelectedUOMId] = useState(null);
  const { t } = useTranslation();
  const initialPagination = createInitialPagination(t)
  const { paginationParams, updatePaginationParams } = usePagination(initialPagination);
  const getCountry = async (
    pagination = paginationParams.pagination,
    filters,
    sorter = {}
  ) => {
    const data = {
      page: pagination?.current,
      per_page: pagination?.pageSize,
      ...filters,
      ...sorter,
    };
    setLoading(true);
    await httpService
      .countryList(data)
      .then((response) => {
        if (response.status == 200) {
          setCountrys(response.data.data?.data);
        }
        updatePaginationParams({
          pagination: {
            ...paginationParams.pagination,
            current: response.data.data.current_page,
            total: response.data.data.total,
            pageSize: response.data.data.per_page,
          },
        });
      })
      .catch((error) => {
        console.error("Error:", error);
        updatePaginationParams({
          pagination: {
            ...paginationParams.pagination,
          },
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleTableChange = async (pagination, filters, sorter) => {
    filters = {
      name: nameFilter,
    };
    const nonNullFilters = Object.fromEntries(
      Object.entries(filters).filter(([, value]) => !!value)
    );
    if (sorter && sorter.field) {
      sorter = {
        sort_by: sorter.field,
        sort_direction: sorter.order == "ascend" ? "ASC" : "DESC",
      };
    }
    if(!pagination){
      pagination = initialPagination
    }
    await updatePaginationParams({
      pagination,
      sorter,
    });
    await getCountry(pagination, nonNullFilters, sorter);
  };
  useEffect(() => {
    setVendor(companies?.data?.data);
    getCountry();
  }, []);
  
  const onConfirmDelete = async (id) => {
    await httpService
      .deleteCountry(id)
      .then((response) => {
        if (response.status == 200) {
          Swal.fire({
            title: t("general.prompts.deleted"),
            text: t("country.countryHasBeenDeleteSuccessfully"),
            className: "btn btn-success",
            confirmButtonText: t("general.button.ok"),
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          getCountry();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const addNewCountry = () => {
    navigate(all_routes.CountryCreate);
  };
  const handleTimezoneClick = (timezone) => {
    const timezoneData = JSON.parse(timezone);

    // Format timezone data
    const formattedTimezones = timezoneData.map((zone) => {
      return `${zone.gmtOffsetName} - ${zone.zoneName} - ${zone.tzName}`;
    });

    Swal.fire({
      title: t("inputField.label.timeZone"),
      html: formattedTimezones.join("<br>"),
      icon: null,
      confirmButtonText: "Close",
      showCancelButton: false,
    });
  };
  const columns = [
    {
      title: t("tableColumnName.srNo"),
      dataIndex: "index",
      align: "center",
      render: (value, item, index) =>
        (paginationParams?.pagination?.current - 1) *
          paginationParams?.pagination?.pageSize +
        (index + 1),
    },
    {
      title: t("tableColumnName.name"),
      dataIndex: "name",
      render: (text, record) => (
        <div className="d-flex">
          <ReactCountryFlag
            style={{
              width: "24px",
              height: "16px",
            }}
            svg
            className="emojiFlag"
            countryCode={record.iso2}
          />
          <p className="ms-2">{record.name}</p>
        </div>
      ),
      sorter: true,
    },
    {
      title: t("inputField.label.currency"),
      dataIndex: "currency",
    },
    {
      title: t("inputField.label.symbol"),
      dataIndex: "currency_symbol",
    },
    {
      title: t("inputField.label.timeZone"),
      dataIndex: "timezones",
      render: (text, record) => (
        <p
          className="text-primary cursor-pointer"
          onClick={() => handleTimezoneClick(record.timezones)}
        >
          <i className="feather-eye"></i>
        </p>
      ),
    },
    {
      title: t("inputField.label.vat"),
      dataIndex: "vat_percentage",
    },
    {
      title: t("tableColumnName.createdAt"),
      dataIndex: "created_at",
      render: (text) => {
        return moment(text).format("DD MMM YYYY - HH:mm:ss");
      },
    },
    {
      title: t("tableColumnName.status"),
      dataIndex: "is_active",
      render: (text, record) => {
        if (record.flag == 1) {
          return (
            <span className="badge badge-linesuccess">
              <a>{t("general.actions.activate")}</a>
            </span>
          );
        } else {
          return (
            <span className="badge badge-linedanger">
              <a>{t("general.actions.deactive")}</a>
            </span>
          );
        }
      },
    },

    {
      title: t("tableColumnName.actions"),
      key: "actions",
      hidden: !hasPermission([
        "country-view",
        "country-edit",
        "country-delete",
      ]),
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            {hasPermission(["country-view"]) && (
              <a
                className="p-2"
                onClick={() => navigate(`/country/${record.id}/details`)}
              >
                <i className="feather-eye"></i>
              </a>
            )}
            {hasPermission(["country-edit"]) && (
              <a
                className="p-2"
                onClick={() => navigate(`/country/${record.id}/edit`)}
              >
                <i className="feather-edit-2 text-black"></i>
              </a>
            )}
            {hasPermission(["country-delete"]) && (
              <ConfirmationAlert onConfirm={() => onConfirmDelete(record.id)} />
            )}
          </div>
        </div>
      ),
    },
  ];
  const breadcrumbItems = [
    { label: "", link: "/", icon: "feather-home" },
    { label: t("tableColumnName.countries"), active: true },
  ];
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex flex-column">
              <div className="page-title">
                <h4> {t("tableColumnName.countries")} </h4>
              </div>
              <UnlimitBreadcrumb items={breadcrumbItems} />
            </div>
            {hasPermission(["country-add"]) && (
              <div className="page-btn">
                <button onClick={addNewCountry} className="btn btn-added">
                  <Plus className="me-2 iconsize" />
                  {t("general.button.addNew")}
                </button>
              </div>
            )}
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top row">
                <div className="col-lg-5 col-sm-5 col-12">
                  <input
                    type="text"
                    placeholder={t("country.enterCountryName")}
                    className="form-control form-control-sm formsearch-custom ps-2"
                    value={nameFilter}
                    onChange={(e) => setNameFilter(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        handleTableChange();
                      }
                    }}
                  />
                </div>
                <div className="col-lg-3 col-sm-4 col-12 ms-auto">
                  <div className="input-blocks mb-0">
                    <button
                      className="btn btn-filters col-auto ms-auto px-2"
                      style={{ width: "fit-content" }}
                      onClick={handleTableChange}
                    >
                      <i data-feather="search" className="feather-search m-0" />{" "}
                    </button>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <UnlimitTable
                  pagination={paginationParams.pagination}
                  columns={columns}
                  dataSource={countrys}
                  rowKey={(record) => record.id}
                  loading={loading}
                  onChange={handleTableChange}
                />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
    </div>
  );
};

export default CountryList;
